import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { GamificationPanel } from '../Gamification';
import { Trophy, Flame } from 'lucide-react';

export function DashboardAchievementsTab({ gamification, loading }) {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
                <GamificationPanel profile={gamification} loading={loading} />
            </div>
            <div>
                <Card className="bg-white/[0.02] border-white/5">
                    <CardHeader>
                        <CardTitle className="text-lg text-white flex items-center gap-2">
                            <Trophy className="w-5 h-5 text-[#FFD700]" />
                            Quick Stats
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="p-3 rounded-lg bg-white/[0.03] border border-white/5">
                            <div className="text-xs text-white/40 mb-1">Current Level</div>
                            <div className="text-2xl font-bold" style={{ color: gamification?.level?.color || '#FFF' }}>
                                {gamification?.level?.name || 'Loading...'}
                            </div>
                        </div>
                        <div className="p-3 rounded-lg bg-white/[0.03] border border-white/5">
                            <div className="text-xs text-white/40 mb-1">Total XP</div>
                            <div className="text-2xl font-bold text-[#00FF66]">
                                {gamification?.xp?.toLocaleString() || '0'} XP
                            </div>
                        </div>
                        <div className="p-3 rounded-lg bg-white/[0.03] border border-white/5">
                            <div className="text-xs text-white/40 mb-1">Badges Earned</div>
                            <div className="text-2xl font-bold text-[#FFD700]">
                                {gamification?.earned_badges?.length || '0'}
                            </div>
                        </div>
                        {gamification?.stats && (
                            <>
                                <div className="p-3 rounded-lg bg-white/[0.03] border border-white/5">
                                    <div className="text-xs text-white/40 mb-1">Best Streak</div>
                                    <div className="text-2xl font-bold text-[#FF6B6B] flex items-center gap-2">
                                        <Flame className="w-5 h-5" />
                                        {gamification.stats.max_streak || 0}
                                    </div>
                                </div>
                                <div className="p-3 rounded-lg bg-white/[0.03] border border-white/5">
                                    <div className="text-xs text-white/40 mb-1">Chains Used</div>
                                    <div className="text-lg font-bold text-white">
                                        {gamification.stats.chains_used || 0} / 3
                                    </div>
                                </div>
                            </>
                        )}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
